import { Global, css } from "@emotion/react";
import styled from "@emotion/styled";

const globalCss = css`
  html,
  body {
    position: relative;
    width: 100%;
    height: 100%;
  }
`;

const Center = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Head = styled.h1`
  font-size: 400%;
`;
const Strap = styled.h2`
  font-size: 200%;
`;

export const App = () => (
  <>
    <Global styles={globalCss}></Global>
    <Center>
      <Head>HeadroomsTV</Head>
      <Strap>We are back ... SOON&trade;</Strap>
    </Center>
  </>
);

export default App;
